import { Controller } from "@hotwired/stimulus"
import { get } from '@rails/request.js'


export default class extends Controller {
  static targets = ['content', 'scrollAnchor']

  async changeTab(e) {
    const response = await get(e.params.url)
    this.contentTarget.innerHTML = await response.html
  }

  async changePage(e) {
    e.preventDefault()
    const url = e.target.href || e.params.url
    const response = await get(url)
    this.contentTarget.innerHTML = await response.html
  }

  async changePageWithScroll(e) {
    e.preventDefault()
    const url = e.target.href || e.params.url
    const response = await get(url)
    this.contentTarget.innerHTML = await response.html
    if (this.hasScrollAnchorTarget) {
      setTimeout(() => {
        this.scrollAnchorTarget.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }, 200)
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }

  async appendContent(e) {
    const response = await get(e.params.url)
    const new_content = await response.html
    this.contentTarget.insertAdjacentHTML( 'beforeend', new_content)
  }
}
